import { getFilename } from 'shared/helpers/getFilename'

import { DownloadTableParams } from '../model/types'

export const downloadTableApi = {
  downloadTable: async ({ url, ...params }: DownloadTableParams) => {
    const queryString = new URLSearchParams(
      params as Record<string, string>,
    ).toString()
    const fullUrl = `/api${url}?${queryString}`
    const res = await fetch(fullUrl)
    if (!res.ok) {
      throw new Error(`Ошибка ${res.status}: ${res.statusText}`)
    }

    const filename = getFilename({ headers: res.headers })
    const csvFile = await res.blob()

    return { filename, csvFile }
  },
}
